import {
  actions,
  getDailyActiveUsersCountAsync,
  getMonthlyActiveUsersAsync,
  getWeeklyActiveUsersAsync,
} from './slices';

export const AnalysisActions = {
  ...actions,
  getDailyActiveUsersCountAsync,
  getMonthlyActiveUsersAsync,
  getWeeklyActiveUsersAsync,
};
